import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../slice/login";
import forgotPasswordSlice from "../slice/forgotPassword";
import linkExpiredSlice from "../slice/linkExpired";
import resetPasswordSlice from "../slice/resetPassword";
import getProfileSlice from "../slice/get-profile";
import updateProfileSlice from "../slice/update-profile";
import changePasswordSlice from "../slice/changePassword";
import getDashboardCountSlice from "../slice/getDashboardCount";
import getBookingSlice from "../slice/getBooking";
import getCustomerSlice from "../slice/getCustomer";
import getAllCustomersSlice from "../slice/getAllCustomers";
import getRoleSlice from "../slice/getRole";
import addRoleSlice from "../slice/AddRole";
import getRoleIdSlice from "../slice/getRoleId";
import editRoleSlice from "../slice/editRole";
import deleteRoleSlice from "../slice/deleteRole";
import getCustomersSlice from "../slice/getCustomers";
import addCustomerSlice from "../slice/AddCustomer";
import getCustomersDetailsSlice from "../slice/getCustomersDetails";
import deleteCustomerSlice from "../slice/deleteCustomer";
import editCustomerSlice from "../slice/editCustomer";
import getStaffSlice from "../slice/getStaffList";
import addStaffSlice from "../slice/AddStaff";
import getStaffByIdSlice from "../slice/getStaffById";
import editStaffSlice from "../slice/EditStaff";
import getRolesByStatusSlice from "../slice/getRolesByQuery";
import deleteStaffSlice from "../slice/deleteStaff";
import addPersonalDetailsChefSlice from "../slice/chef/add/personal-details";
import addProfessionalDetailsChefSlice from "../slice/chef/add/professional-details";
import getChefSlice from "../slice/chef/list";
import getChefDetailByIdSlice from "../slice/chef/get-by-id";
import getBookingIdSlice from "../slice/getBookingId";
import getCuisineSlice from "../slice/getCuisine";
import addCuisineSlice from "../slice/AddCuisine";
import getCuisineDetailsSlice from "../slice/getCuisineDetails";
import editCuisineSlice from "../slice/editCuisine";
import deleteCuisineSlice from "../slice/deleteCuisine";
import getBookingDetailsSlice from "../slice/getBookingDetails";
import getmasterCuisinesSlice from "../slice/master/cuisines";
import getLanguagesSlice from "../slice/master/languages";
import getChefStatusSlice from "../slice/getChefStatus";
import getChefVerifiedSlice from "../slice/getChefVerified";
import addChefImageSlice from "../slice/AddChefImages";
import addAreaDetailsSlice from "../slice/AddAreaDetails";
import addressDetailsSlice from "../slice/AddAddressDetails";
import addratesDetailsSlice from "../slice/AddRatesDetails";
import getChefRatesSlice from "../slice/getChefRates";
import getDishesSlice from "../slice/getDishes";
import getCusineMasterSlice from "../slice/getCusineMaster";
import addDishesSlice from "../slice/AddDishes";
import getDishesDetailsSlice from "../slice/getDishesDetails"
import editDishesSlice from "../slice/EditDishes"
import deleteDishesSlice from "../slice/deletedishes"
import getCustomersRatingReviewSlice from "../slice/getCustomersRatingReview"
import getChefRatingReviewSlice from "../slice/getChefRatingReview"
import getNotificationSlice from "../slice/getNotification"
import getContactSlice from "../slice/getContact"
import getContactDetailsSlice from "../slice/getContactDetails"
import getCouponsSlice from "../slice/getCoupons"
import addCouponsSlice from "../slice/AddCoupons"
import getCouponsDetailsSlice from "../slice/getCouponsDetails"
import editCouponsSlice from "../slice/editCoupons"
import deleteCouponsSlice from "../slice/deleteCoupons"
import deleteGrocerySlice from "../slice/deleteGrocery"
import searchDishesSlice from "../slice/searchDishes"
import searchDishesGrocerySlice from "../slice/searchDishesGrocery"
import getSlots from "../slice/master/slots"
import addGeneralAvailabilityChef from "../slice/chef/add/general-availability";
import configSlice from "../slice/config";
import notificationManagementSlice from "../slice/notification-management";
import transactionSlice from "../slice/transaction";
import transactionDetailSlice from "../slice/transactionDetail";
import cmsManagementSlice from "../slice/cms-management";
import reportManagementSlice from "../slice/report-management";
import getReportsSlice from "../slice/getReports"
import getChefsDashboardCountSlice from "../slice/getChefsDashboard"
import getUpdateStatusSlice from "../slice/getUpdateStatus"
import getUpdateCuisenStatusSlice from "../slice/getUpdateCuisenStatus"
import getUpdateDishesStatusSlice from "../slice/getUpdateDishesStatus"
import allCustomerSlice from "../slice/allCustomer"
import ratingreviewdetailsSlice from "../slice/ratingreviewDetails"
import dishConfigSlice from "../slice/dish-config-management"
import deleteContactSlice from "../slice/deleteContact"
import cloneBooking from "../slice/cloneBooking"
import getCuisineListSlice from "../slice/getCuisineList"
import getDishesListSlice from "../slice/getDishesList"
import editChefMenuSlice from "../slice/EditChefMenu"
import getChefMenuSlice from "../slice/getChefMenuId"
import addVacationSlice from "../slice/AddVacation"
import editBookingSlice from "../slice/editBooking"
import getChefListSlice from "../slice/getChefList"
import addBookingSlice from "../slice/Addbooking"
import getSlotsSlice from "../slice/getSlots"
import getRateSummarySlice from "../slice/getRateSummary" 
import cloneBookSlice from "../slice/cloneBook"
import setAddressSlice from "../slice/setAddress"
import loaderSlice from "../slice/LoaderSlice";
import deleteBookingSlice from "../slice/deleteBooking"
import stripeConnectSlice from "../slice/stripeConnectSlice";
const store = configureStore({
  reducer: {
    login: loginSlice,
    forgotPassword: forgotPasswordSlice,
    linkExpired: linkExpiredSlice,
    resetPassword: resetPasswordSlice,
    getProfile: getProfileSlice,
    updateProfile: updateProfileSlice,
    changePassword: changePasswordSlice,
    getDashboardCount: getDashboardCountSlice,
    getBooking: getBookingSlice,
    getCustomer: getCustomerSlice,
    getRole: getRoleSlice,
    addRole: addRoleSlice,
    getRoleId: getRoleIdSlice,
    editRole: editRoleSlice,
    deleteRole: deleteRoleSlice,
    getCustomers: getCustomersSlice,
    getAllCustomers:getAllCustomersSlice,
    addCustomer: addCustomerSlice,
    getCustomersDetails: getCustomersDetailsSlice,
    deleteCustomer: deleteCustomerSlice,
    editCustomer: editCustomerSlice,
    getStaff: getStaffSlice,
    addStaff: addStaffSlice,
    getStaffById: getStaffByIdSlice,
    editStaff: editStaffSlice,
    getRolesByStatus: getRolesByStatusSlice,
    deleteStaff: deleteStaffSlice,
    getBookingId: getBookingIdSlice,
    getChef: getChefSlice,
    getChefDetailById: getChefDetailByIdSlice,
    getCuisine: getCuisineSlice,
    addCuisine: addCuisineSlice,
    getCuisineDetails: getCuisineDetailsSlice,
    editCuisine: editCuisineSlice,
    deleteCuisine: deleteCuisineSlice,
    getBookingDetails: getBookingDetailsSlice,
    addPersonalDetailsChef: addPersonalDetailsChefSlice,
    addProfessionalDetailsChef: addProfessionalDetailsChefSlice,
    getmasterCuisines: getmasterCuisinesSlice,
    getChefStatus: getChefStatusSlice,
    getChefVerified: getChefVerifiedSlice,
    getLanguages: getLanguagesSlice,
    addChefImage: addChefImageSlice,
    addAreaDetails: addAreaDetailsSlice,
    addressDetails: addressDetailsSlice,
    addratesDetails: addratesDetailsSlice,
    getChefRates: getChefRatesSlice,
    getDishes: getDishesSlice,
    getCusineMaster: getCusineMasterSlice,
    addDishes: addDishesSlice,
    getDishesDetails: getDishesDetailsSlice,
    editDishes: editDishesSlice,
    deleteDishes: deleteDishesSlice,
    getCustomersRatingReview: getCustomersRatingReviewSlice,
    getChefRatingReview: getChefRatingReviewSlice,
    getNotification: getNotificationSlice,
    getContact: getContactSlice,
    getContactDetails: getContactDetailsSlice,
    getCoupons: getCouponsSlice,
    addCoupons: addCouponsSlice,
    getCouponsDetails: getCouponsDetailsSlice,
    editCoupons: editCouponsSlice,
    deleteCoupons: deleteCouponsSlice,
    deleteGrocery: deleteGrocerySlice,
    searchDishes: searchDishesSlice,
    searchDishesGrocery:searchDishesGrocerySlice,
    getReports: getReportsSlice,
    transaction: transactionSlice,
    transactionDetail: transactionDetailSlice,
    getSlots,
    configSlice,
    cmsManagementSlice,
    reportManagementSlice,
    dishConfigSlice,
    addGeneralAvailabilityChef,
    notificationManagementSlice,
    getChefsDashboardCount:getChefsDashboardCountSlice,
    getUpdateStatus:getUpdateStatusSlice,
    getUpdateCuisenStatus:getUpdateCuisenStatusSlice,
    getUpdateDishesStatus:getUpdateDishesStatusSlice,
    allCustomer:allCustomerSlice,
    ratingreviewdetails:ratingreviewdetailsSlice,
    deleteContact:deleteContactSlice,
    cloneBooking,
    getCuisineList:getCuisineListSlice,
    getDishesList:getDishesListSlice,
    editChefMenu:editChefMenuSlice,
    getChefMenu:getChefMenuSlice,
    addVacation:addVacationSlice,
    editBooking:editBookingSlice,
    getChefList:getChefListSlice,
    addBooking:addBookingSlice,
    getSlotsBooking:getSlotsSlice,
    getRateSummary:getRateSummarySlice,
    cloneBook:cloneBookSlice,
    setAddress:setAddressSlice,
    loader:loaderSlice,
    deleteBooking:deleteBookingSlice,
    stripeConnect:stripeConnectSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
